import * as Cesium from 'cesium';
import * as turf from '@turf/turf';
import { LinearScaleOutlined, SignalCellularNullOutlined, PlaceOutlined } from "@mui/icons-material";


export function Zoomtopoint(viewer, longitude, latitude) {
    var terrainProvider = Cesium.createWorldTerrainAsync();
    var positions = [Cesium.Cartographic.fromDegrees(longitude, latitude)];
    Cesium.sampleTerrainMostDetailed(terrainProvider, positions).then((updatedPositions) => {
        let altitude = updatedPositions[0].height;
        viewer.camera.flyTo({ destination: Cesium.Cartesian3.fromDegrees(longitude, latitude, altitude + 50) });
    }).catch(() => {
        let altitude = positions[0].height;
        viewer.camera.flyTo({ destination: Cesium.Cartesian3.fromDegrees(longitude, latitude, altitude + 50) });
    })
}

//Manage entity visibility by id
export function manageEntityVisibilityById(flag, annotation, viewer, annotationIndex) {
    //console.log(annotationIndex);
    //Get element
    let entity = window.GlobalAnnotationEntities.entities.getById(annotation);

    if (Cesium.defined(entity)) {

        //console.log(obj);
        if (flag == true) {
            entity.show = false;

            if (window.annotationObj[annotationIndex] !== undefined) {
                window.annotationObj[annotationIndex].LabelVisibility = false;
            }

            //If the feature is a polygon we manage outlines as well
            if (entity.name == 'Polygon') {
                window.GlobalAnnotationEntities.entities.getById(`${entity.id}PolygonOutline`).show = false;
            }

        } else {
            //console.log(window.actualAnnotationId);
            entity.show = true;

            if (window.annotationObj[annotationIndex] !== undefined) {
                window.annotationObj[annotationIndex].LabelVisibility = true;
            }


            //If the feature is a polygon we manage outlines as well
            if (entity.name == 'Polygon') {
                window.GlobalAnnotationEntities.entities.getById(`${entity.id}PolygonOutline`).show = true;

            }


        }
    }
    /*viewer.entities.values.map((obj, index) => {
        if (obj.id == annotation) {
            //console.log(obj);
            if (flag == true) {
                obj.show = false;
                window.annotationObj[annotationIndex].LabelVisibility = false;

                //If the feature is a polygon we manage outlines as well
                if (obj.name == 'Polygon') {
                    viewer.entities.getById(`${obj.id}PolygonOutline`).show = false;

                }

            } else {
                //console.log(window.actualAnnotationId);
                obj.show = true;

                window.annotationObj[annotationIndex].LabelVisibility = true;

                //If the feature is a polygon we manage outlines as well
                if (obj.name == 'Polygon') {
                    viewer.entities.getById(`${obj.id}PolygonOutline`).show = true;

                }


            }

        }
        if (obj.id == annotation + 'Outline') {
            //console.log(obj);
            if (flag == true) {
                obj.show = false;
                if (window.actualAnnotationId !== undefined) {
                    window.annotationObj[window.actualAnnotationId].LabelVisibility = false;
                }


            } else {
                //console.log(window.actualAnnotationId);
                obj.show = true;
                if (window.actualAnnotationId !== undefined) {
                    window.annotationObj[window.actualAnnotationId].LabelVisibility = true;
                }

            }

        }
    })*/
}

//Get midpoint between two points
function getMidpoint(currentPointArray, previousPointArray) {
    var geodesic = new Cesium.EllipsoidGeodesic();
    let currentPoint = Cesium.Cartographic.fromDegrees(currentPointArray[0], currentPointArray[1], currentPointArray[2]);
    let previousPoint = Cesium.Cartographic.fromDegrees(previousPointArray[0], previousPointArray[1], previousPointArray[2]);
    var scratch = new Cesium.Cartographic();

    geodesic.setEndPoints(currentPoint, previousPoint);
    var midpointCartographic = geodesic.interpolateUsingFraction(0.5, scratch);
    return Cesium.Cartesian3.fromRadians(midpointCartographic.longitude, midpointCartographic.latitude, midpointCartographic.height);

}

//Get distance between two points
function getDistanceString(currentPointArray, previousPointArray) {
    var geodesic = new Cesium.EllipsoidGeodesic();
    let currentPoint = Cesium.Cartographic.fromDegrees(currentPointArray[0], currentPointArray[1]);
    let previousPoint = Cesium.Cartographic.fromDegrees(previousPointArray[0], previousPointArray[1]);

    geodesic.setEndPoints(currentPoint, previousPoint);
    var meters = Math.round(geodesic.surfaceDistance);
    if (meters >= 1000) {
        return (meters / 1000).toFixed(1) + ' km';
    }
    return meters + ' m';
}

//Draw saved annotations from backend
export function Drawannotation(geometryType, geometry, ID, viewer, ItemIndex) {
    if (geometryType === 'POLYLINE') {
        let geometryData = geometry.replace('LINESTRING Z (', '');
        geometryData = geometryData.replace(')', '');
        var find = ', ';
        var re = new RegExp(find, 'g');
        geometryData = geometryData.replace(re, ',');
        let GeomVertexArray = geometryData.split(",");
        let geomArray = [];
        GeomVertexArray.forEach((obj, index) => {
            let coordinate = obj.split(" ");
            let long = parseFloat(coordinate[0]);
            let lat = parseFloat(coordinate[1]);
            let height = parseFloat(coordinate[2]);
            geomArray.push(long);
            geomArray.push(lat);
            geomArray.push(height >= 0 ? height : 1);
        })

        window.GlobalAnnotationEntities.entities.add({
            id: ID,
            show: true,
            polyline: {
                positions: Cesium.Cartesian3.fromDegreesArrayHeights(geomArray),
                width: window.annotationObj[ItemIndex].LineWidth,
                material: window.annotationObj[ItemIndex].FillColor.withAlpha(window.annotationObj[ItemIndex].LineFillTransparency),
                outlineColor: window.annotationObj[ItemIndex].FillColor.withAlpha(window.annotationObj[ItemIndex].LineFillTransparency),
                clampToGround: false
            },
        });
    } else if (geometryType === 'POLYGON') {
        let geometryData = geometry.replace('POLYGON Z ((', '');
        geometryData = geometryData.replace('))', '');
        var find = ', ';
        var re = new RegExp(find, 'g');
        geometryData = geometryData.replace(re, ',');
        let GeomVertexArray = geometryData.split(",");
        let geomArray = [];
        GeomVertexArray.forEach((obj, index) => {
            let coordinate = obj.split(" ");
            let long = parseFloat(coordinate[0]);
            let lat = parseFloat(coordinate[1]);
            let height = parseFloat(coordinate[2]);
            geomArray.push(long);
            geomArray.push(lat);
            geomArray.push(height >= 0 ? height : 1);
        })

        window.GlobalAnnotationEntities.entities.add({
            name: "Polygon",
            id: ID,
            show: true,
            polygon: {
                hierarchy: Cesium.Cartesian3.fromDegreesArrayHeights(geomArray),
                material: Cesium.Color.fromCssColorString('#FFFFFF').withAlpha(window.annotationObj[`${ItemIndex}`].PolygonFillTransparency),
                perPositionHeight: true
            },
        });
        
        window.GlobalAnnotationEntities.entities.add({
            name: 'TaskingPolyline',
            id: `${ID}PolygonOutline`,
            show: true,
            polyline: {
                positions: Cesium.Cartesian3.fromDegreesArrayHeights(geomArray),
                width: window.annotationObj[`${ItemIndex}`] ? window.annotationObj[`${ItemIndex}`].LineWidth : 5,
                material: window.annotationObj[ItemIndex].FillColor.withAlpha(window.annotationObj[ItemIndex].LineFillTransparency),
                outlineColor: window.annotationObj[ItemIndex].FillColor.withAlpha(window.annotationObj[ItemIndex].LineFillTransparency),
                clampToGround: false,
            },
        });
    } else if (geometryType === 'Point') {
        let geometryData = geometry.replace('POINT Z (', '');
        geometryData = geometryData.replace(')', '');
        var find = ', ';
        var re = new RegExp(find, 'g');
        geometryData = geometryData.replace(re, ',');
        let coordinate = geometryData.split(" ");
        let lon = parseFloat(coordinate[0]);
        let lat = parseFloat(coordinate[1]);
        let height = parseFloat(coordinate[2]);
        MarkerAnnotationStyle();
        window.GlobalAnnotationEntities.entities.add({
            position: Cesium.Cartesian3.fromDegrees(lon, lat, height >= 0 ? height : 1),
            id: ID,
            show: true,
            billboard: {
                image: new Cesium.CallbackProperty(function () {
                    if (window.annotationObj[`${ItemIndex}`]) {
                        return window.annotationObj[`${ItemIndex}`].PinMarker;
                    }
                }, false),
                width: new Cesium.CallbackProperty(function () {
                    if (window.annotationObj[`${ItemIndex}`].pinwidth) {
                        return window.annotationObj[`${ItemIndex}`].pinwidth;
                    }
                }, false),
                height: new Cesium.CallbackProperty(function () {
                    if (window.annotationObj[`${ItemIndex}`].pinheight) {
                        return window.annotationObj[`${ItemIndex}`].pinheight;
                    }
                }, false),
            }
        });
    }
}

const clearDataExportModalVariablesFromViewer = (viewer) => {
    if (window.exportPolygon) {
        viewer.entities.remove(window.exportPolygon);
        delete (window.exportPolygon);
    }
    
    if (window.exportRectangle) {
        viewer.entities.remove(window.exportRectangle);
        delete (window.exportRectangle);
    }
    
    if (window.kmlExportPolygon) {
        viewer.entities.remove(window.kmlExportPolygon);
        delete (window.kmlExportPolygon);
    }
    
    if (window.geojsonExportPolygon) {
        viewer.entities.remove(window.geojsonExportPolygon);
        delete (window.geojsonExportPolygon);
    }
}

const clearDataDownloadVariablesFromViewer = (viewer) => {
    if (window.selectedPolygon) {
        viewer.entities.remove(window.selectedPolygon);
        delete (window.selectedPolygon);
    }
    
    if (window.itemsPolygon) {
        viewer.entities.remove(window.itemsPolygon);
        delete (window.itemsPolygon);
    }
    
    if (window.polygons) {
        Object.keys(window.polygons).forEach((id) => viewer.entities.remove(window.polygons[id]));
        delete (window.polygons);
    }
    
    if (window.collectionDetailMoveEndListener && viewer.camera.moveEnd) {
        viewer.camera.moveEnd.removeEventListener(window.collectionDetailMoveEndListener);
        delete window.collectionDetailMoveEndListener;
    }
}

export const clearProjectVariablesFromViewer = (viewer) => {
    clearDataExportModalVariablesFromViewer(viewer);
    clearDataDownloadVariablesFromViewer(viewer);
}

//Clear Global variable in case we switch from Measure to pin
export function ClearGlobalVariables(viewer, clear_annotation = true) {
    //Clear pin Variables************************************
    //Clear Global and primitive before Start Drawing

    //Clear point from global variable
    delete window['CurrentPointCentroid'];
    delete window['CurrentPointCentroidArrayFormat'];

    //Remove primitive
    if (window.hasOwnProperty('CurrentPinMarker')) {

        viewer.scene.primitives.remove(window['CurrentPinMarker']);
    }

    delete window['CurrentPinMarker'];

    //Clear Measurement Variables
    //Clear Handler
    if (window.hasOwnProperty('handlerEditPolygonGeom')) {
        window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
        window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
        window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_UP);
        window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOWN);
        window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
        window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.RIGHT_CLICK);
        delete window['handlerEditPolygonGeom'];
    }

    if (window.handlerDrawPointGeom) {
        window.handlerDrawPointGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
        window.handlerDrawPointGeom.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
        delete (window.handlerDrawPointGeom);
    }

    //Clear Globals
    if (window.hasOwnProperty('taskingFeaturesArray')) {
        window.taskingFeaturesArray.map((obj, index) => {
            viewer.entities.remove(obj);
        })
    }

    //If we need to remove entites
    if (clear_annotation == true) {
        if (window.hasOwnProperty('GlobalAnnotationEntities')) {
            window.GlobalAnnotationEntities.entities.removeAll();
        }
    }


    viewer.entities.remove(window.floatingPoint);
    viewer.entities.remove(window.activeShape);
    window.activeShapePoints = [];
    delete (window.activeShapePoints);
    delete (window.activeShape);
    delete (window.Shapepoints);
    delete (window.lineNodes);
    delete (window.floatingPoint);
    delete (window.CurrentMeasureShape)

    //Close Tooltip
    var tooltipSpan = document.querySelector('.tooltipDrawing');
    tooltipSpan.style.display = 'none';
}

export function GetDrawnShape(CurentConcernedShape, viewer) {
    if (window.hasOwnProperty(CurentConcernedShape)) {
        let polygonGeometry = window[CurentConcernedShape]['Geometry'];
        let geometryType = window[CurentConcernedShape]['GeometryType'];
        let shapeString = '';
        //Check if Line or polygon
        if (geometryType == 'POLYGON') {
            shapeString = `POLYGON((`;
            polygonGeometry.map((obj, index) => {
                let cartesianPoint = GetCartoFromCartesian(obj);
                let lon = cartesianPoint[0];
                let lat = cartesianPoint[1];
                let height = cartesianPoint[2];
                if (index < polygonGeometry.length - 1) {
                    shapeString = `${shapeString}${lon} ${lat} ${height},`;
                } else {
                    let firstpoint = GetCartoFromCartesian(polygonGeometry[0]);
                    shapeString = `${shapeString}${lon} ${lat} ${height},${firstpoint[0]} ${firstpoint[1]} ${firstpoint[2]}`;
                }
            });
            shapeString = `${shapeString}))`;
        } else if (geometryType == 'POLYLINE') {
            shapeString = `LINESTRING(`;
            polygonGeometry.map((obj, index) => {
                let cartesianPoint = GetCartoFromCartesian(obj);
                let lon = cartesianPoint[0];
                let lat = cartesianPoint[1];
                let height = cartesianPoint[2];
                if (index < polygonGeometry.length - 1) {
                    shapeString = `${shapeString}${lon} ${lat} ${height},`;
                } else {
                    shapeString = `${shapeString}${lon} ${lat} ${height}`;
                }
            });
            shapeString = `${shapeString})`;
        }
        //Remove Created Feature
        delete window[CurentConcernedShape];

        window.taskingFeaturesArray.map((obj, index) => {
            viewer.entities.remove(obj);
        })

        return shapeString;
    }
}
export function radians_to_degrees(radians) {
    var pi = Math.PI;
    return radians * (180 / pi);
}
function GetCartoFromCartesian(cartesian) {
    let carto = Cesium.Ellipsoid.WGS84.cartesianToCartographic(cartesian);
    let lon = radians_to_degrees(carto.longitude);
    let lat = radians_to_degrees(carto.latitude);
    return [lon, lat, carto.height >= 0 ? carto.height : 1];
}
//get current entity to edit
export function getMousePositionPointerEntity(viewer, position) {
    let pickedEntities = viewer.scene.drillPick(position, 1);
    return pickedEntities;
    /*for (let i = 0; i < pickedEntities.length; i++) {
        if (pickedEntities[i].id == undefined) continue;
        if (pickedEntities[i].id._id == undefined) continue;
        if (typeof pickedEntities[i].id._id !== 'string') continue;
        if (pickedEntities[i].id._id.includes('_check') ||
            (pickedEntities[i].id._name && pickedEntities[i].id._name.startsWith('markerannotation_')) ||
            (pickedEntities[i].id._name && pickedEntities[i].id._name.startsWith('line_')) ||
            (pickedEntities[i].id._name && pickedEntities[i].id._name.startsWith('polygon_')) ||
            pickedEntities[i].id._id.startsWith('midpolygonpoint_') ||
            pickedEntities[i].id._id.startsWith('midpointline_'))
            return pickedEntities[i];
    }

    return undefined;*/
}
function getALLMousePositionPointerEntity(viewer, position) {
    let pickedEntities = viewer.scene.drillPick(position);
    return pickedEntities;
    /*for (let i = 0; i < pickedEntities.length; i++) {
        if (pickedEntities[i].id == undefined) continue;
        if (pickedEntities[i].id._id == undefined) continue;
        if (typeof pickedEntities[i].id._id !== 'string') continue;
        if (pickedEntities[i].id._id.includes('_check') ||
            (pickedEntities[i].id._name && pickedEntities[i].id._name.startsWith('markerannotation_')) ||
            (pickedEntities[i].id._name && pickedEntities[i].id._name.startsWith('line_')) ||
            (pickedEntities[i].id._name && pickedEntities[i].id._name.startsWith('polygon_')) ||
            pickedEntities[i].id._id.startsWith('midpolygonpoint_') ||
            pickedEntities[i].id._id.startsWith('midpointline_'))
            return pickedEntities[i];
    }

    return undefined;*/
}
// Draw polygon function
export function generateNodeImage(color, selected) {
    let circleImage = new Image();
    circleImage.setAttribute("colorAttribute", "000000");
    circleImage.setAttribute("colorOpacity", 1);
    //console.log(color);
    let circle_svg;
    if (!selected) {
        circle_svg = '<svg width="100" height="100" viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg"><circle cx = "50" cy = "50" r = "40" stroke="' + color + '" stroke-width="20" fill = "white" fill-opacity="0.25" /></svg >';
    } else {
        circle_svg = '<svg width="100" height="100" viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg"><circle cx = "50" cy = "50" r = "40" stroke="' + color + '" stroke-width="20" fill = "white" fill-opacity="0.25" /></svg >';
    }
    circleImage.src = 'data:image/svg+xml;base64,' + window.btoa(circle_svg);

    return circleImage;
}

//Style annotation
export function MarkerAnnotationStyle() {

    let circleImage = new Image();
    circleImage.setAttribute("colorAttribute", "000000");
    circleImage.setAttribute("colorOpacity", 1);
    //console.log(color);
    let circle_svg;
    circle_svg = `${process.env.PUBLIC_URL} /materialSvgIcons/local_airport_black_48dp.svg`;
    circleImage.src = 'data:image/svg+xml;base64,' + window.btoa(circle_svg);

    return circleImage;
}

//Functions to convert measurement then return value
function defineNewMeasurementValue(measurementValue, Factor, measurementUnit) {

    let value = 0;
    if (measurementUnit == 'm') {
        value = (parseFloat(measurementValue) * Factor).toFixed(2);
    } else if (measurementUnit == 'm²') {
        value = (parseFloat(measurementValue) * Math.pow(Factor, 2)).toFixed(2);
    }

    return value;
}
const onChangeDimension = (measurementValue, event, mOrmsquare) => {
    let LineDimension = event;
    //console.log(LineDimension);
    switch (LineDimension) {
        case 'ft':
            return defineNewMeasurementValue(measurementValue, 3.28084, mOrmsquare);
            break;
        case 'ml':
            return defineNewMeasurementValue(measurementValue, 0.000621371, mOrmsquare);
            break;
        case 'km':
            return defineNewMeasurementValue(measurementValue, 0.001, mOrmsquare);
            break;
        case 'yr':
            return defineNewMeasurementValue(measurementValue, 1.09361, mOrmsquare);
            break;
        case 'm':
            return defineNewMeasurementValue(measurementValue, 1, mOrmsquare);
            break;
        default:
            return defineNewMeasurementValue(measurementValue, 1, 'm');
        // code block
    }
    //console.log(event);
};

export function ToolTipDisplay(id, position, text_to_display) {
    var tooltipSpan = document.querySelector('.tooltipDrawing');
    var tooltiptext = document.querySelector('.tooltipDrawingtext');
    if (id == 1) {
        let x = position.x;
        let y = position.y;
        tooltipSpan.style.display = 'table';
        tooltipSpan.style.top = (y - 10) + 'px';
        tooltipSpan.style.left = (x + 24.75) + 'px';
        tooltiptext.innerHTML = text_to_display;
    } else if (id == 2) {
        tooltipSpan.style.display = 'none';
    }
}

export function DrawPin(viewer, iconFile = 'defaultMarker.svg', color = "#487BF2", size = 50, setcurrentMeasurementValue, setcurrentLonLat) {
    document.getElementById("cesium-wrapper").style.cursor = 'crosshair';
    if (!window['CurrentPointCentroid']) window['CurrentPointCentroid'] = 0;
    window['handlerDrawPointGeom'] = new Cesium.ScreenSpaceEventHandler(viewer.canvas);
    window.handlerDrawPointGeom.setInputAction((event) => {
        ToolTipDisplay(2);
        window.handlerDrawPointGeom.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
        var position = getWorldPosition(viewer.scene, event.position, viewer.entities);
        if (Cesium.defined(position)) {
            const Cartographic_point = GetCartoFromCartesian(position);
            let DrawMarker = AddMarker(viewer, 'Location_Marker', iconFile, Cartographic_point[0], Cartographic_point[1], Cartographic_point[2], size);
            window['CurrentPinMarker'] = DrawMarker;
            
            if (!window['CurrentPinMarker'].PinColor) window['CurrentPinMarker'].PinColor = Cesium.Color.fromCssColorString(color);
            if (!window['CurrentPinMarker'].pinwidth) window['CurrentPinMarker'].pinwidth = size;
            if (!window['CurrentPinMarker'].pinheight) window['CurrentPinMarker'].pinheight = size;
            window['CurrentPinMarker'].PinName = `${iconFile}`;
            
            GetSVGContent(window['CurrentPinMarker'].PinColor.toCssHexString(), window['CurrentPinMarker'], function (result) {
                window['CurrentPinMarker'].PinMarker = result.src;
                window['CurrentPinMarker']._billboards[0].image = result.src;
            })
            window['CurrentPointCentroid'] = `${Cartographic_point[0]}, ${Cartographic_point[1]}`;
            setcurrentLonLat(window['CurrentPointCentroid']);

            window['currentPinHeight'] = Math.round(Cartographic_point[2] * 100) / 100;
            setcurrentMeasurementValue(Math.round(Cartographic_point[2] * 100) / 100);
            window['CurrentPointCentroidArrayFormat'] = Cartographic_point;
            window.handlerDrawPointGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
            document.getElementById("cesium-wrapper").style.cursor = 'default';
            delete (window.handlerDrawPointGeom);
        }
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

    window.handlerDrawPointGeom.setInputAction(function (event) {

        var Position = viewer.scene.pickPosition(event.endPosition);
        if (Position) {
            let pixel_position = Cesium.SceneTransforms.wgs84ToWindowCoordinates(viewer.scene, Position);

            ToolTipDisplay(1, pixel_position, 'Click to place marker');

        }

    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
}

export function EditPolygonVertices(viewer, theOriginForDrawing, color = '#487BF2', CheckIfLineIsDrawed = true) {
    //Add Handler to edit Vertex
    let activeeditedpoints = [];
    let dragged_pointID;
    function Drawvertex(vertex, index, color, size) {

        //Generate location variables
        let Xvertex = vertex.x;
        let Yvertex = vertex.y;
        let Zvertex = vertex.z;
        window['X' + index] = Xvertex;
        window['Y' + index] = Yvertex;
        window['Z' + index] = Zvertex;
        let dynamic_point = Cesium.Cartesian3.fromElements(window['X' + index], window['Y' + index], window['Z' + index]);
        activeeditedpoints.push(dynamic_point);
        let circleImage = generateNodeImage(color, true);
        var point = viewer.entities.add({
            id: `EditPolygonVertex${index}`,
            name: 'TaskingPointsVertex',
            parent: window.boxesEditedPolygon,
            position: new Cesium.CallbackProperty(function () {
                return Cesium.Cartesian3.fromElements(window['X' + index], window['Y' + index], window['Z' + index]);
            }, false),
            billboard: {
                image: circleImage,
                //horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                //verticalOrigin: Cesium.VerticalOrigin.CENTER,
                width: size,
                height: size,
                // heightReference: Cesium.HeightReference.CLAMP_TO_GROUND
                //heightReference: Cesium.HeightReference.NONE,
                //scaleByDistance: new Cesium.NearFarScalar(1.5e2, 2.0, 1.5e7, 0.5)
            }
        });
        window.taskingFeaturesArray.push(point);
    }

    window.handlerEditPolygonGeom = new Cesium.ScreenSpaceEventHandler(viewer.canvas);

    window.handlerEditPolygonGeom.setInputAction(function (event) {
        //console.log(viewer.entities);
        let entity = getALLMousePositionPointerEntity(window.MAIN_CESIUM_VIEWER, event.position);
        // console.log(entity);
        //console.log(entity);
        //If we pick feature we display vertxes
        if (entity.length > 0) {
            entity.map((obj, index) => {
                //Manage polygon Edition if drew
                // console.log(CheckIfLineIsDrawed);
                if (Cesium.defined(obj.id) && Cesium.defined(obj.id._polygon) & (CheckIfLineIsDrawed == false)) {
                    // if (Cesium.defined(obj.id) && Cesium.defined(obj.id._polygon)) {
                    if (obj.id.name == 'TaskingPolygon' & obj.id._polygon.hierarchy._value !== undefined) {
                        //polygons not functional yet

                        //Diseable terrain
                        //viewer.terrainProvider = new Cesium.EllipsoidTerrainProvider();
                        viewer.scene.globe.depthTestAgainstTerrain = true;
                        //Remove drew features before we add vertices
                        //boxes.show = false;
                        window.taskingFeaturesArray.map((obj, index) => {
                            viewer.entities.remove(obj);
                        })
                        window.taskingFeaturesArray = [];


                        let polygon_vertex_array = obj.id._polygon.hierarchy._value.positions;
                        //Count vertices
                        const vertexcount = polygon_vertex_array.length;
                        //console.log(vertexcount);
                        //Draw polygon vertices*************
                        let vertexe_counter = 0;
                        polygon_vertex_array.map((vertex, index) => {
                            //console.log(index);
                            if (index < vertexcount - 1) {
                                let actualPoint = vertex;
                                let nextPoint = polygon_vertex_array[index + 1];
                                let middlepoint = {};
                                middlepoint.x = (actualPoint.x + nextPoint.x) / 2;
                                middlepoint.y = (actualPoint.y + nextPoint.y) / 2;
                                middlepoint.z = (actualPoint.z + nextPoint.z) / 2;
                                //Draw a vertexe
                                Drawvertex(actualPoint, vertexe_counter, color, 20);
                                vertexe_counter++;

                                //Draw Middlepoint
                                //let middle_index = parseInt(`${index}${vertexcount}`);
                                Drawvertex(middlepoint, vertexe_counter, color, 10);
                                vertexe_counter++;
                            } else {
                                let actualPoint = vertex;
                                let nextPoint = polygon_vertex_array[0];
                                let middlepoint = {};
                                middlepoint.x = (actualPoint.x + nextPoint.x) / 2;
                                middlepoint.y = (actualPoint.y + nextPoint.y) / 2;
                                middlepoint.z = (actualPoint.z + nextPoint.z) / 2;
                                //Draw a vertexe
                                Drawvertex(actualPoint, vertexe_counter, color, 20);
                                vertexe_counter++;
                                //Draw Middlepoint
                                //let middle_index = parseInt(`${index}${vertexcount}`);
                                Drawvertex(middlepoint, vertexe_counter, color, 10);
                                vertexe_counter++;
                            }


                        })

                        window.activeShapePoints = activeeditedpoints;
                        //Disable left click once we start editing so user can't edit twice
                        window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
                    }
                } else if (obj && obj.id && Cesium.defined(obj.id.polyline) & (CheckIfLineIsDrawed == true)) {
                    if (obj.id.name == 'TaskingPolyline' & obj.id.polyline.positions !== undefined) { // Manage polyline if Drew

                        //Diseable terrain
                        //viewer.terrainProvider = new Cesium.EllipsoidTerrainProvider();
                        viewer.scene.globe.depthTestAgainstTerrain = true;
                        //Remove drew features before we add vertices
                        //boxes.show = false;
                        window.taskingFeaturesArray.map((obj, index) => {
                            viewer.entities.remove(obj);
                        })
                        window.taskingFeaturesArray = [];

                        // let polygon_vertex_array = obj.id.polyline.positions._value;
                        let polygon_vertex_array = window.activeShapePoints;
                        //Count vertices
                        const vertexcount = polygon_vertex_array.length;
                        //console.log(vertexcount);
                        //Draw polygon vertices*************
                        let vertexe_counter = 0;
                        polygon_vertex_array.map((vertex, index) => {
                            //console.log(index);
                            if (index < vertexcount - 1) {
                                let actualPoint = vertex;
                                let nextPoint = polygon_vertex_array[index + 1];
                                let middlepoint = {};
                                middlepoint.x = (actualPoint.x + nextPoint.x) / 2;
                                middlepoint.y = (actualPoint.y + nextPoint.y) / 2;
                                middlepoint.z = (actualPoint.z + nextPoint.z) / 2;
                                //Draw a vertexe
                                Drawvertex(actualPoint, vertexe_counter, color, 20);
                                vertexe_counter++;

                                //Draw Middlepoint
                                //let middle_index = parseInt(`${index}${vertexcount}`);
                                Drawvertex(middlepoint, vertexe_counter, color, 10);
                                vertexe_counter++;
                            } else {
                                let actualPoint = vertex;
                                let nextPoint = polygon_vertex_array[0];
                                let middlepoint = {};
                                middlepoint.x = (actualPoint.x + nextPoint.x) / 2;
                                middlepoint.y = (actualPoint.y + nextPoint.y) / 2;
                                middlepoint.z = (actualPoint.z + nextPoint.z) / 2;
                                //Draw a vertexe
                                Drawvertex(actualPoint, vertexe_counter, color, 20);
                                vertexe_counter++;
                                //Draw Middlepoint
                                //let middle_index = parseInt(`${index}${vertexcount}`);
                                //Drawvertex(middlepoint, vertexe_counter, 'green', 10);
                                //vertexe_counter++;
                            }


                        })

                        window.activeShapePoints = activeeditedpoints;

                        //Disable left click once we start editing so user can't edit twice
                        window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
                    }
                }
            })
        }
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

    //Handle Dragging
    var dragging;

    window.handlerEditPolygonGeom.setInputAction(function (click) {
        var pickedObject = viewer.scene.pick(click.position);
        if (Cesium.defined(pickedObject) && pickedObject.id && pickedObject.id._id /*&& pickedObject.id === point*/) {
            dragged_pointID = pickedObject.id._id;
            dragging = pickedObject;
            viewer.scene.screenSpaceCameraController.enableRotate = false;
        }
    }, Cesium.ScreenSpaceEventType.LEFT_DOWN);

    window.handlerEditPolygonGeom.setInputAction(function () {
        viewer.scene.screenSpaceCameraController.enableRotate = true;
        if (Cesium.defined(dragging)) {
            dragging = undefined;
            // viewer.scene.screenSpaceCameraController.enableRotate = true;
            //When user finish vertex edition we store the new geometry
            window[theOriginForDrawing]['Geometry'] = activeeditedpoints;
            //Store Geometry type so we check if user draw line or polygon
            if (CheckIfLineIsDrawed === false) {
                window[theOriginForDrawing]['GeometryType'] = 'POLYGON';
            } else {
                window[theOriginForDrawing]['GeometryType'] = 'POLYLINE';
            }
        }
    }, Cesium.ScreenSpaceEventType.LEFT_UP);

    window.handlerEditPolygonGeom.setInputAction(function (movement) {
        viewer.scene.globe.depthTestAgainstTerrain = true;
        var position = viewer.camera.pickEllipsoid(movement.endPosition);
        if (!Cesium.defined(position) || !dragging) {
            //Change cursor is Tasking polygon is hover
            let entity = getALLMousePositionPointerEntity(window.MAIN_CESIUM_VIEWER, movement.endPosition);
            document.getElementById("cesium-wrapper").style.cursor = 'default';
            //If we pick feature we display vertices
            if (entity.length > 0) {
                entity.map((obj, index) => {
                    if (obj.id) {
                        if (Cesium.defined(obj.id._polygon)) {
                            if (obj.id.name == 'TaskingPolygon' & obj.id._polygon.hierarchy._value !== undefined) {
                                document.getElementById("cesium-wrapper").style.cursor = 'pointer';
                            }
                        } else if (Cesium.defined(obj.id.polyline)) {
                            if (obj.id.name == 'TaskingPolyline' & obj.id.polyline.positions !== undefined) {
                                document.getElementById("cesium-wrapper").style.cursor = 'pointer';
                            }
                        }
                    }
                });
            }
            return;
        }

        var cartesian = getWorldPosition(viewer.scene, movement.endPosition, viewer.entities);
        if (Cesium.defined(cartesian)) {
            // We retreive the selected point to drag then edit value of it index
            //let Pointindex = dragged_pointID.charAt(dragged_pointID.length - 1);
            let Pointindex = dragged_pointID.match(/\d/g);
            if (Pointindex) {
                Pointindex = Pointindex.join("");
                //console.log(Pointindex);
                window[`X${parseInt(Pointindex)}`] = cartesian.x;
                window[`Y${parseInt(Pointindex)}`] = cartesian.y;
                window[`Z${parseInt(Pointindex)}`] = cartesian.z;
                let dynamic_point = Cesium.Cartesian3.fromElements(cartesian.x, cartesian.y, cartesian.z);
                activeeditedpoints[parseInt(Pointindex)] = dynamic_point;
            }
            //console.log(cartesian);
        }

    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
}

const getCentroidFromCartographicCoordinate = (cartographic_points) => {
    const polygon = turf.polygon([cartographic_points]);
    const centroid = turf.centroid(polygon);
    return centroid;
}

const getCentroidFromCartesianCoordinate = (cartesian_points) => {
    let geographic_points_array = [];
    cartesian_points.map((obj) => {
        geographic_points_array.push(GetCartoFromCartesian(obj));
    })
    geographic_points_array.push(GetCartoFromCartesian(cartesian_points[0]));
    const centroid = getCentroidFromCartographicCoordinate(geographic_points_array);
    return centroid;
}

export const getAreaFromCartographicCoordinates = (cartographic_points) => {
    const polygon = turf.polygon([cartographic_points]);
    const area = turf.area(polygon);
    return area
}

export const getAreaFromCartesianPoints = (cartesian_points) => {
    let geographic_points_array = [];
    cartesian_points.map((obj) => {
        geographic_points_array.push(GetCartoFromCartesian(obj));
    })
    geographic_points_array.push(GetCartoFromCartesian(cartesian_points[0]));
    const area = getAreaFromCartographicCoordinates(geographic_points_array);
    return area;
}

export function DrawPolygon(viewer, theOriginForDrawing, AllowLines = false, DisplayMeasurement = false, color = '#487BF2', alpha = 1, width = 4, dispatch, setcurrentMeasurementValue, setcurrentLonLat) {
    document.getElementById("cesium-wrapper").style.cursor = 'crosshair';
    var entities = viewer.entities;
    var boxes = entities.add(new Cesium.Entity());
    var boxesEditedPolygon = entities.add(new Cesium.Entity());
    window.handlerEditPolygonGeom = new Cesium.ScreenSpaceEventHandler(viewer.canvas);
    window.taskingFeaturesArray = [];
    window.vertexeArray = [];
    window['finishdrawing'] = false;
    let PermissionToDraw = true;
    let distance = 10;
    let CheckIfLineIsDrawed = false;
    window[theOriginForDrawing] = [];
    window[theOriginForDrawing]['CurrentDistance'] = 0;
    window['CurrentDistanceLeftMouse'] = 0;
    window['CurrentPolygonArea'] = 0;
    window['CurrentPolygonCentroid'] = '';
    window.boxes = boxes;
    window.boxesEditedPolygon = boxesEditedPolygon;
    viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);

    function createPoint(worldPosition, ID, color = '#487BF2') {
        let position = worldPosition;
        let circleImage = generateNodeImage(color, true);
        var point = viewer.entities.add({
            name: 'TaskingPoints',
            id: `CircleVertex${ID}`,
            parent: boxes,
            position: position,
            billboard: {
                image: circleImage,
                horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                verticalOrigin: Cesium.VerticalOrigin.CENTER,
                width: 15,
                height: 15,
                heightReference: Cesium.HeightReference.NONE
            }
        });
        window.taskingFeaturesArray.push(point);
        window.vertexeArray.push(point);
        return point;
    }

    var drawingMode = "polygon";
    function drawDashSegment(TwoCartesian, color, alpha, width = 4) {
        var polyline = viewer.entities.add({
            name: 'TaskingPolyline',
            parent: boxes,
            polyline: {
                positions: TwoCartesian,
                width: width,
                material: new Cesium.PolylineOutlineMaterialProperty({
                    color: Cesium.Color.fromCssColorString(color).withAlpha(alpha),
                    outlineColor: Cesium.Color.fromCssColorString(color).withAlpha(alpha)
                }),
                clampToGround: new Cesium.CallbackProperty(function () {
                    return window['straightShape'];
                }, false),
            },
        });

        return polyline;
    }

    function drawShape(positionData, parentname) {
        var shape;
        if (drawingMode === "line") {
            shape = viewer.entities.add({
                polyline: {
                    positions: positionData,
                    clampToGround: (window['straightShape'] == undefined || window['straightShape'] == true ? false : true),
                    width: 3,
                },
            });
        } else if (drawingMode === "polygon") {
            shape = viewer.entities.add({
                name: 'TaskingPolygon',
                parent: parentname,
                polygon: {
                    hierarchy: positionData,
                    material: new Cesium.ColorMaterialProperty(
                        Cesium.Color.WHITE.withAlpha(0.25)
                    ),
                    perPositionHeight: (window['straightShape'] == undefined || window['straightShape'] == true ? true : false),
                    arcType: Cesium.ArcType.GEODESIC
                },
            });

            window.taskingFeaturesArray.push(shape);
        }
        return shape;
    }
    
    if (!window.activeShapePoints) window.activeShapePoints = [];
    if (!window.Shapepoints) window.Shapepoints = [];
    if (!window.lineNodes) window.lineNodes = [];

    var geodesic = new Cesium.EllipsoidGeodesic();
    function getLength(startLongitude, startLatitude, endLongitude, endLatitude) {
        var startPoint = Cesium.Cartographic.fromDegrees(startLongitude, startLatitude);
        var endPoint = Cesium.Cartographic.fromDegrees(endLongitude, endLatitude);
        geodesic.setEndPoints(startPoint, endPoint);
        var lengthInMeters = geodesic.surfaceDistance;
        return lengthInMeters.toFixed(2);
    }

    window.handlerEditPolygonGeom.setInputAction((event) => {
        var position = getWorldPosition(viewer.scene, event.position, viewer.entities);
        if (Cesium.defined(position)) {
            window.Shapepoints.push(position);
            const Cartographic_point = GetCartoFromCartesian(position);
            window['CurrentPolygonCentroid'] = `${Cartographic_point[0]}, ${Cartographic_point[1]}`;
            if (window.Shapepoints.length >= 2) {
                if (distance < 0.25) {
                    PermissionToDraw = false;
                    terminateShape(viewer);
                }
            }
            if (PermissionToDraw == true) {
                if (window.activeShapePoints.length === 0) {
                    window.floatingPoint = createPoint(position, null, color);
                    window.activeShapePoints.push(position);
                    var dynamicPositions = new Cesium.CallbackProperty(function () {
                        return window.activeShapePoints;
                    }, false);

                    window.activeShape = drawDashSegment(dynamicPositions, color, alpha, width);
                    window.activeShape.FillColor = Cesium.Color.fromCssColorString(color);
                    window.activeShape.Polygonoutlinecolor = Cesium.Color.fromCssColorString(color);
                    window.activeShape.LineFillTransparency = alpha;
                    window.activeShape.LineWidth = width;
                }

                window.activeShapePoints.push(position);
                window.lineNodes.push(createPoint(position, window.Shapepoints.length - 1, color));
            }
            
            if (window.Shapepoints.length > 1) {
                let startingPoint = GetCartoFromCartesian(window.Shapepoints[window.Shapepoints.length - 2]);
                let endingPoint = GetCartoFromCartesian(position);
                let distanceInmeter = getLength(startingPoint[0], startingPoint[1], endingPoint[0], endingPoint[1]);
                window['CurrentDistanceLeftMouse'] = parseFloat(window['CurrentDistanceLeftMouse']) + parseFloat(distanceInmeter);
                setcurrentLonLat(window['CurrentPolygonCentroid']);
            }
        }
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

    if (AllowLines == true) {
        window.handlerEditPolygonGeom.setInputAction(function (event) {
            CheckIfLineIsDrawed = true;
            window.activeShapePoints.pop();
            terminateShape(viewer);
        }, Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
    }

    window.handlerEditPolygonGeom.setInputAction(function (event) {
        if (Cesium.defined(window.floatingPoint)) {
            var newPosition = getWorldPosition(viewer.scene, event.endPosition, viewer.entities);

            if (Cesium.defined(newPosition)) {
                window.floatingPoint.position.setValue(newPosition);
                window.activeShapePoints.pop();
                window.activeShapePoints.push(newPosition);
            }
        }

        var Position = getWorldPosition(viewer.scene, event.endPosition, viewer.entities);
        if (Position) {
            let pixel_position = Cesium.SceneTransforms.wgs84ToWindowCoordinates(viewer.scene, Position);
            if (window.Shapepoints.length == 0) {
                ToolTipDisplay(1, pixel_position, 'Click for starting point');
            } else if (window.Shapepoints.length >= 1) {
                if (DisplayMeasurement === false) {
                    ToolTipDisplay(1, pixel_position, 'Click to draw area');
                } else {
                    let startingPoint = GetCartoFromCartesian(window.Shapepoints[window.Shapepoints.length - 1]);
                    let endingPoint = GetCartoFromCartesian(Position);
                    let distanceInmeter = getLength(startingPoint[0], startingPoint[1], endingPoint[0], endingPoint[1]);
                    setcurrentMeasurementValue(window['CurrentDistanceLeftMouse'] + parseFloat(distanceInmeter));
                    window[theOriginForDrawing]['CurrentDistance'] = distanceInmeter;
                    let actualunit = window['actualUnit'];
                    if (actualunit == 'm') {
                        ToolTipDisplay(1, pixel_position, `Distance: ${distanceInmeter} m <br/>Double click to close Polyline`);
                    } else {
                        let measure = onChangeDimension(distanceInmeter, actualunit, 'm');
                        ToolTipDisplay(1, pixel_position, measure + ` ${actualunit}`);
                    }
                }

            } else {
                ToolTipDisplay(2);
            }

            if (window.Shapepoints.length > 2) {
                let startingPoint = GetCartoFromCartesian(Position);
                let endingPoint = GetCartoFromCartesian(window.Shapepoints[0]);
                distance = getLength(startingPoint[0], startingPoint[1], endingPoint[0], endingPoint[1]);
                if (distance < 0.25) {
                    const area = getAreaFromCartesianPoints(window.Shapepoints);
                    ToolTipDisplay(2);
                    ToolTipDisplay(1, pixel_position, `Area: ${area.toFixed(2)} m²<br/>Click to close Polygon`);
                }
            }
        }
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

    const terminateShape = (viewer) => {
        window.activeShapePoints.pop();
        window['finishdrawing'] = true;
        if (CheckIfLineIsDrawed == false) {
            dispatch({
                "type": "SET_SELECTED_EDITING_ANNOTATION", editingAnnotation: {
                    type: 'Polygon'
                }
            })

            window.activeShapePoints = [...window.activeShapePoints, window.activeShapePoints[0]];
            drawShape(window.activeShapePoints, boxes);
            const area = getAreaFromCartesianPoints(window.activeShapePoints);
            const centroid = getCentroidFromCartesianCoordinate(window.activeShapePoints);
            window['CurrentPolygonArea'] = area.toFixed(2);
            setcurrentMeasurementValue(window['CurrentPolygonArea']);
            window['CurrentPolygonCentroid'] = `${centroid.geometry.coordinates[0]}, ${centroid.geometry.coordinates[1]} `;
            setcurrentLonLat(window['CurrentPolygonCentroid']);
            window.activeShape.polygon = {
                hierarchy: new Cesium.PolygonHierarchy(window.activeShapePoints),
                material: Cesium.Color.fromCssColorString('#FFFFFF').withAlpha(0.35),
                perPositionHeight: true
            }
            window.activeShape.PolygonFillTransparency = 0.35;
        }

        window[theOriginForDrawing]['Geometry'] = window.activeShapePoints;
        if (CheckIfLineIsDrawed === false) {
            window[theOriginForDrawing]['GeometryType'] = 'POLYGON';
        } else {
            window[theOriginForDrawing]['GeometryType'] = 'POLYLINE';
        }

        window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
        window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
        window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_UP);
        window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOWN);
        window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
        window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.RIGHT_CLICK);
        delete (window.handlerEditPolygonGeom);
        EditPolygonVertices(viewer, theOriginForDrawing, color);
        ToolTipDisplay(2);
        document.getElementById("cesium-wrapper").style.cursor = 'default';
    }
}

export function ManageAnnotationList(viewer, obj, currentAnnotationId, AnnotationTypes) {
    const annotationType = obj.fields.annotationType;
    const annotationmeasurement = obj.fields.annotationInMeter.split(" ")[0];
    const annotationmeasurementUnit = obj.fields.annotationInMeter.split(" ")[1];
    const annotationname = obj.fields.annotationName;
    const annotationdescription = obj.fields.annotationDescription;
    
    let centroidData = obj.fields.annotationCentroid;
    centroidData.replace(' ', '');
    let centroidArray = centroidData.split(',');
    const centroid = `${parseFloat(centroidArray[0])}, ${parseFloat(centroidArray[1])}`;
    const anotationgeometry = obj.fields.geometry.replace('SRID=4326;', '');
    const anotationID = obj.pk;
    
    let objString = obj.fields.annotationStyle;
    let styleobj = JSON.parse(objString);
    if (styleobj.hasOwnProperty('LineFillTransparency') == false) {
        styleobj.LineFillTransparency = 1
    }

    if (styleobj.hasOwnProperty('PolygonFillTransparency') == false) {
        styleobj.PolygonFillTransparency = 0.35
    }
    
    if (styleobj.hasOwnProperty('PinMarker') == false) {
        styleobj.PinMarker = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGlkPSJtYXJrZXJfc2ltcGxlX2xhcmdlIj4NCjxnIGlkPSIjYW5ub3RhdGlvbi1tYXJrZXIiPg0KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTQ2LjI1IDI1LjVDNDYuMjUgMzEuOTI1IDQxIDM5Ljk3NSAzMC44NSA0OS4yNzVMMzAgNTAuMDI1TDI5LjE1IDQ5LjI1QzE5IDM5Ljk3NSAxMy43NSAzMS45MjUgMTMuNzUgMjUuNUMxMy43NSAxNS45IDIwLjggOC43NSAzMCA4Ljc1QzM5LjIgOC43NSA0Ni4yNSAxNS44NzUgNDYuMjUgMjUuNVoiIGZpbGw9IndoaXRlIi8+DQo8cGF0aCBpZD0iVmVjdG9yXzIiIGQ9Ik0zMCA1QzQwLjUgNSA1MCAxMy4wNSA1MCAyNS41QzUwIDMzLjggNDMuMzI1IDQzLjYyNSAzMCA1NUMxNi42NzUgNDMuNjI1IDEwIDMzLjggMTAgMjUuNUMxMCAxMy4wNSAxOS41IDUgMzAgNVpNNDUgMjUuNUM0NSAxNi40MjUgMzguMzc1IDEwIDMwIDEwQzIxLjYyNSAxMCAxNSAxNi40MjUgMTUgMjUuNUMxNSAzMS4zNSAxOS44NzUgMzkuMSAzMCA0OC4zNUM0MC4xMjUgMzkuMSA0NSAzMS4zNSA0NSAyNS41Wk0zMCAzMEMyNy4yNSAzMCAyNSAyNy43NSAyNSAyNUMyNSAyMi4yNSAyNy4yNSAyMCAzMCAyMEMzMi43NSAyMCAzNSAyMi4yNSAzNSAyNUMzNSAyNy43NSAzMi43NSAzMCAzMCAzMFoiIGZpbGw9IiM0ODdCRjIiLz4NCjwvZz4NCjwvZz4NCjwvc3ZnPg0K';
    }

    let annotationObj = {
        'Idannotation': anotationID,
        'FillColor': Cesium.Color.fromCssColorString(styleobj.FillColor),
        "LineFillTransparency": styleobj.LineFillTransparency,
        "PolygonFillTransparency": styleobj.PolygonFillTransparency,
        'LineWidth': styleobj.LineWidth,
        'PinName': styleobj.PinName,
        'pinwidth': styleobj.pinwidth,
        'pinheight': styleobj.pinheight,
        'PinColor': Cesium.Color.fromCssColorString(styleobj.PinColor),
        'PinMarker': styleobj.PinMarker,
        'Labelfontsize': styleobj.Labelfontsize,
        'LabelfillColor': Cesium.Color.fromCssColorString(styleobj.LabelfillColor),
        'LabelVisibility': false,
        'Polygonoutlinecolor': Cesium.Color.fromCssColorString(styleobj.Polygonoutlinecolor)
    }

    window.annotationObj.push(annotationObj);
    let ItemIndex = window.annotationObj.indexOf(annotationObj);
    if (annotationType === 'POLYLINE') {
        let annotation = {
            icon: <LinearScaleOutlined />,
            label: annotationname,
            type: AnnotationTypes.Line,
            title: "Line Name",
            value: `${annotationmeasurement} ${annotationmeasurementUnit}`,
            dimension: "2D",
            description: centroid,
            geometry: anotationgeometry,
            annotationId: anotationID,
            lastaddedannotation: currentAnnotationId,
            annotationname: annotationname,
            annotationdescription: annotationdescription
        }

        if (window.annotationObj) {
            Drawannotation(annotationType, anotationgeometry, anotationID, viewer, ItemIndex);
        }
        
        return annotation;
    } else if (annotationType === 'POLYGON') {
        let annotation = {
            icon: <SignalCellularNullOutlined />,
            label: annotationname,
            type: AnnotationTypes.Area,
            title: "Area Name",
            value: `${annotationmeasurement} ${annotationmeasurementUnit}`,
            dimension: "2D",
            description: centroid,
            geometry: anotationgeometry,
            annotationId: anotationID,
            lastaddedannotation: currentAnnotationId,
            annotationname: annotationname,
            annotationdescription: annotationdescription
        }
        
        window.GlobalAnnotationEntities.entities.removeById(`${anotationID}PolygonOutline`);
        Drawannotation(annotationType, anotationgeometry, anotationID, viewer, ItemIndex);
        
        return annotation;
    } else if (annotationType === 'Point') {
        let geometryData = anotationgeometry.replace('POINT Z (', '');
        geometryData = geometryData.replace(')', '');
        var find = ', ';
        var re = new RegExp(find, 'g');
        geometryData = geometryData.replace(re, ',');
        let coordinate = geometryData.split(" ");
        let height = parseFloat(coordinate[2]);
        let annotation = {
            icon: <PlaceOutlined />,
            label: annotationname,
            type: AnnotationTypes.Marker,
            title: "Marker Name",
            value: `${(Math.round(height * 100) / 100)} ${annotationmeasurementUnit}`,//height default
            dimension: "3D",
            description: centroid,
            geometry: anotationgeometry,
            annotationId: anotationID,
            lastaddedannotation: currentAnnotationId,
            annotationname: annotationname,
            annotationdescription: annotationdescription,
            height: height,
            terrainHeight: annotationmeasurement
        }
        
        Drawannotation(annotationType, anotationgeometry, anotationID, viewer, ItemIndex);
        return annotation;
    }
}

export function AddMarker(viewer, collectionName, type, locationX, locationY, height, size = 50) {
    //console.log(viewer, collectionName, type, locationX, locationY);
    var ellipsoid = viewer.scene.globe.ellipsoid;
    var billboard_Collection = viewer.scene.primitives.add(new Cesium.BillboardCollection({
        scene: viewer.scene
    }));

    billboard_Collection.add({
        position: Cesium.Cartesian3.fromDegrees(locationX, locationY, height),
        // image: `${process.env.PUBLIC_URL}/images/${type}`,
        image: `${process.env.PUBLIC_URL}/materialSvgIcons/${type}`,
        // heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
        heightReference: (window['straightShape'] ? Cesium.HeightReference.CLAMP_TO_GROUND : Cesium.HeightReference.NONE),
        width: size,
        height: size
    });

    return billboard_Collection;
    /*
    var collection = new Cesium.CustomDataSource(
        collectionName
    );
    var citizensBankPark = collection.entities.add({
        //name: 'Citizens Bank Park',
        //id: 'ggg',
        position: Cesium.Cartesian3.fromDegrees(
            locationX,
            locationY
        ),
        billboard: {
            image: `${process.env.PUBLIC_URL}/images/${type}`,
            width: 40,
            height: 50
        }
    });
    viewer.dataSources.add(collection);*/
}

//Draw svg
export function GetSVGContent(color, annotation, callback) {
    var request = new XMLHttpRequest();
    request.open("GET", `${process.env.PUBLIC_URL} /materialSvgIcons/${annotation.PinName}`);
    request.setRequestHeader("Content-Type", "image/svg+xml");
    request.addEventListener("load", function (event) {
        let response = event.target.responseText;
        //console.log(annotation.PinName, response, color);
        var find = '#487BF2';
        var re = new RegExp(find, 'g');

        var destination = color;

        response = response.replace(re, destination);
        //console.log(response);

        let svg;
        var image = new Image();
        svg = 'data:image/svg+xml;base64,' + window.btoa(response);

        image.onload = function () {
            callback(image);
        };

        image.src = svg;
        //console.log(response);
    });
    request.send();
}

//get current BBOX
export function getBBOX(viewer) {
    let scratchRectangle = new Cesium.Rectangle();
    let rect = viewer.camera.computeViewRectangle(viewer.scene.globe.ellipsoid, scratchRectangle);
    return [Cesium.Math.toDegrees(rect.west).toFixed(4), Cesium.Math.toDegrees(rect.east).toFixed(4), Cesium.Math.toDegrees(rect.south).toFixed(4), Cesium.Math.toDegrees(rect.north).toFixed(4)];
}
export function BBOX_CENTROID(west, east, south, north) {
    let long = (parseFloat(west) + parseFloat(east)) / 2;
    let lat = (parseFloat(south) + parseFloat(north)) / 2;
    return [long, lat];
}
export function getCameraFocus(viewer) {
    var rayScratch = new Cesium.Ray();
    rayScratch.origin = viewer.camera.positionWC;
    rayScratch.direction = viewer.camera.directionWC;
    return viewer.scene.globe.pick(rayScratch, viewer.scene);
}

export function cameraReset3D(viewer, radius, offset) {
    var destination;
    var focus = getCameraFocus(viewer);
    if (focus === undefined) {
        destination = viewer.camera.position;
    }
    else {
        destination = focus;
    }

    viewer.camera.flyToBoundingSphere(new Cesium.BoundingSphere(destination, radius), {
        offset: offset,
        duration: 0.5
    });
}

export function enableTiltCesium(viewer, enable) {
    viewer.scene.screenSpaceCameraController.enableTilt = enable;
}

export function animationZoom(viewer, amount) {
    var focus = getCameraFocus(viewer);
    var orientation;

    if (focus !== undefined) {
        orientation = {
            direction: viewer.camera.direction,
            up: viewer.camera.up
        };
    }
    else {
        var ray = new Cesium.Ray(viewer.camera.worldToCameraCoordinatesPoint(viewer.scene.globe.ellipsoid.cartographicToCartesian(viewer.camera.positionCartographic)), viewer.camera.directionWC);
        focus = Cesium.IntersectionTests.grazingAltitudeLocation(ray, viewer.scene.globe.ellipsoid);

        orientation = {
            heading: viewer.camera.heading,
            pitch: viewer.camera.pitch,
            roll: viewer.camera.roll
        };
    }
    var cartesian3Scratch = new Cesium.Cartesian3();
    var direction = Cesium.Cartesian3.subtract(viewer.camera.position, focus, cartesian3Scratch);
    var movementVector = Cesium.Cartesian3.multiplyByScalar(direction, amount, direction);
    var endPosition = Cesium.Cartesian3.add(focus, movementVector, focus);

    viewer.camera.flyTo({
        destination: endPosition,
        orientation: orientation,
        duration: 0.5,
        convert: false
    });
}
//********************************* */ mouse move handling
function defined(value) {
    return value !== undefined && value !== null;
}

function getWorldPosition(scene, mousePosition, primitives, result) {
    var position;
    var cartesianScratch = new Cesium.Cartesian3();
    var rayScratch = new Cesium.Ray();
    var ray = scene.camera.getPickRay(mousePosition, rayScratch);
    if (scene.pickPositionSupported) {
        var pickedObjects = scene.drillPick(mousePosition, 2, 1, 1);   //doesn't ignore billboards with hide and restore, falls through or jumps on models //drill pick instead
        for (let i = 0; i < pickedObjects.length; i++) {
            var pickedObject = pickedObjects[i];
            if (defined(pickedObject) && (pickedObject instanceof Cesium.Cesium3DTileFeature || pickedObject.primitive instanceof Cesium.Cesium3DTileset || pickedObject.primitive instanceof Cesium.Model)) { // check to let us know if we should pick against the globe instead
                let pickResult = scene.pickFromRay(ray, primitives._entities.array);
                if (defined(pickResult)) {
                    return Cesium.Cartesian3.clone(pickResult.position, result);
                }
            }
        }
    }

    if (!defined(scene.globe)) {
        return;
    }

    position = scene.globe.pick(ray, scene, cartesianScratch);
    if (defined(position)) {
        const TERRAIN_HEIGHT_OFFSET = 1; // 1 m above surface
        var carto = Cesium.Ellipsoid.WGS84.cartesianToCartographic(position);
        carto.height = carto.height >= 0 ? carto.height : TERRAIN_HEIGHT_OFFSET;
        var offsetPosition = Cesium.Ellipsoid.WGS84.cartographicToCartesian(carto, result);
        return Cesium.Cartesian3.clone(offsetPosition, result);
    }
}

function getHeightFromLocation(height) {
    if (height) {
        return (Math.abs(height).toFixed(3) + "m");
    }
    return (" Elevation 0m");
}

function locationToString(lon, lat) {
    var convertedString = "";

    let latStr = Math.abs(lat).toFixed(4);
    convertedString += latStr + "°";
    if (lat > 0) convertedString += "N";
    else convertedString += "S"

    let lonStr = Math.abs(lon).toFixed(4);
    convertedString += lonStr + "°";
    if (lon > 0) convertedString += "E";
    else convertedString += "W";

    return convertedString;
}

export function getGlobePositionWithTerrain(viewer, windowPosition) {
    var position = getWorldPosition(viewer.scene, windowPosition, viewer.entities);

    if (!position) return position;
    var cartographicPosition = Cesium.Ellipsoid.WGS84.cartesianToCartographic(position);

    return cartographicPosition;
}

function getcurrentcameraheight(viewer) {
    var scene = viewer.scene;
    var camera = scene.camera;
    var height = camera.positionCartographic.height;
    return `Camera: ${Math.round(height)}m`;
}

export function mouseMoveAction(movement, viewer) {
    let cameraheight = getcurrentcameraheight(viewer);
    let position = getGlobePositionWithTerrain(viewer, movement.endPosition);
    if (!position) {
        return;
    }
    var lon = Cesium.Math.toDegrees(position.longitude);
    var lat = Cesium.Math.toDegrees(position.latitude);
    var height = position.height;
    let location_data = locationToString(lon, lat);
    let height_from_location = getHeightFromLocation(height);
    let array_data = `${cameraheight}@${location_data}@${height_from_location}`;
    return array_data;
}

export default DrawPolygon